<h1 automation-id="fn-ui-dialog-header">
    <ng-container *ngTemplateOutlet="header"></ng-container>
</h1>
<div mat-dialog-content automation-id="fn-ui-dialog-body">
    <ng-container *ngTemplateOutlet="body" ></ng-container>
</div>
<div mat-dialog-actions align="end" automation-id="fn-ui-dialog-footer">
    <ng-container *ngTemplateOutlet="footer" ></ng-container>
</div>
